import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Button,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import './styles.css';
import { contactUsPhone } from 'utils/consts';
import WhatsImg from '../../images/whats.png';

function Plans(props) {
  const showTitle = props.showTitle === undefined ? true : props.showTitle;

  return (
    <Container
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <Typography
        align="center"
        variant="h4"
        style={{
          fontWeight: 'bold',
          fontStyle: 'italic',
          display: 'flex',
          marginBottom: '20px',
        }}
      >
        {showTitle ? 'Nossos Planos' : null}
      </Typography>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        spacing={2}
        style={{ flex: 1 }}
      >
        <div style={{ overflow: 'auto' }}>
          <table>
            <thead>
              <tr>
                <th style={{ backgroundColor: '#545454', padding: '1rem' }}>&nbsp;</th>
                <th style={{ backgroundColor: '#545454', padding: '1rem 8rem' }}><b style={{ color: '#fff', fontWeight: '700' }}>Plano 1</b></th>
                <th style={{ backgroundColor: '#545454', padding: '1rem 8rem' }}><b style={{ color: '#fff', fontWeight: '700' }}>Plano 2</b></th>
                <th style={{ backgroundColor: '#545454', padding: '1rem 8rem' }}><b style={{ color: '#fff', fontWeight: '700' }}>Plano 3</b></th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td style={{
                  border: 'solid 1px #C4C4C4', padding: '1.5rem', fontWeight: '700', textAlign: 'center',
                }}
                >
                  Preço Mensal
                </td>
                <td style={{
                  border: 'solid 1px #C4C4C4', textAlign: 'center', backgroundColor: '#0986FF', color: '#fff', fontWeight: '700', fontSize: '24px',
                }}
                >
                  R$ 100,00
                </td>
                <td style={{
                  border: 'solid 1px #C4C4C4', textAlign: 'center', backgroundColor: '#00A9D4E5', color: '#fff', fontWeight: '700', fontSize: '24px',
                }}
                >
                  R$ 150,00
                </td>
                <td style={{
                  border: 'solid 1px #C4C4C4', textAlign: 'center', backgroundColor: '#699BF7', color: '#fff', fontWeight: '700', fontSize: '24px',
                }}
                >
                  R$ 233,00
                </td>
              </tr>
              <tr>
                <td style={{
                  border: 'solid 1px #C4C4C4', padding: '1.5rem', fontWeight: '700', textAlign: 'center',
                }}
                >
                  Quantidade de Viveiros
                </td>
                <td style={{ border: 'solid 1px #C4C4C4', textAlign: 'center', fontWeight: '700' }}>10 Viveiros</td>
                <td style={{ border: 'solid 1px #C4C4C4', textAlign: 'center', fontWeight: '700' }}>25 Viveiros</td>
                <td style={{ border: 'solid 1px #C4C4C4', textAlign: 'center', fontWeight: '700' }}>50 Viveiros</td>
              </tr>
              <tr>
                <td style={{
                  textAlign: 'center', border: 'solid 1px #C4C4C4', padding: '1.5rem', fontWeight: '700',
                }}
                >
                  Quantidade de usuários
                </td>
                <td colSpan="3" style={{ textAlign: 'center', border: 'solid 1px #C4C4C4' }}>Usuários ilimitados para qualquer plano.</td>
              </tr>
              <tr>
                <td style={{
                  border: 'solid 1px #C4C4C4', padding: '1.5rem', fontWeight: '700', textAlign: 'center',
                }}
                >
                  Consultoria
                </td>
                <td colSpan="3" style={{ textAlign: 'center', border: 'solid 1px #C4C4C4' }}>
                  <span>O primeiro diagnóstico é gratuito e remoto.</span>
                </td>
              </tr>
              <tr>
                <td style={{
                  border: 'solid 1px #C4C4C4', padding: '1.5rem', fontWeight: '700', textAlign: 'center',
                }}
                >
                  Módulos disponíveis nos planos
                </td>
                <td colSpan="3" style={{ textAlign: 'center', border: 'solid 1px #C4C4C4' }}>
                  <b> Integração com todos os módulos da metodologia:</b>
                  <li style={{ paddingRight: '8rem' }}>Módulo financeiro;</li>
                  <li>Módulo de comercialização (LinkFish).</li>
                </td>
              </tr>
              <tr>
                <td style={{
                  border: 'solid 1px #C4C4C4', padding: '1.5rem', fontWeight: '700', textAlign: 'center',
                }}
                >
                  Serviços adicionais (Valores a definir)
                </td>
                <td colSpan="3" style={{ border: 'solid 1px #C4C4C4', paddingLeft: '10rem' }}>
                  <li>Contamos com especialistas de engenharia de pesca para lhe auxiliar em sua produção;</li>
                  <li>Módulo de sensores;</li>
                  <li>Módulo de contagem de alevinos (Em desenvolvimento).</li>
                </td>
              </tr>
            </tbody>

            <tfoot>
              <td style={{ border: 'solid 1px #C4C4C4', padding: '1rem' }} />
              <td style={{ border: 'solid 1px #C4C4C4', padding: '1rem' }}>
                <Button
                  href={`https://api.whatsapp.com/send?phone=${contactUsPhone}&text=Oi%2C%20quero%20assinar%20o%20plano%201!`}
                  target="_blank"
                  variant="contained"
                  style={{
                    background: '#0986FF', color: '#fff', borderRadius: '20px', width: '19rem',
                  }}
                >
                  <img src={WhatsImg} style={{ padding: '0.5rem' }} />
                  <span style={{ padding: '0.5rem' }}>Saber mais sobre o plano 1</span>
                </Button>
              </td>
              <td style={{ border: 'solid 1px #C4C4C4', padding: '1rem' }}>
                <Button
                  href={`https://api.whatsapp.com/send?phone=${contactUsPhone}&text=Oi%2C%20quero%20assinar%20o%20plano%202!`}
                  target="_blank"
                  variant="contained"
                  style={{
                    background: '#00A9D4E5', color: '#fff', borderRadius: '20px', width: '19rem',
                  }}
                >
                  <img src={WhatsImg} style={{ padding: '0.5rem' }} />
                  <span style={{ padding: '0.5rem' }}>Saber mais sobre o plano 2</span>
                </Button>
              </td>
              <td style={{ border: 'solid 1px #C4C4C4', padding: '1rem' }}>
                <Button
                  href={`https://api.whatsapp.com/send?phone=${contactUsPhone}&text=Oi%2C%20quero%20assinar%20o%20plano%203!`}
                  target="_blank"
                  variant="contained"
                  style={{
                    background: '#699BF7', color: '#fff', borderRadius: '20px', width: '19rem',
                  }}
                >
                  <img src={WhatsImg} style={{ padding: '0.5rem' }} />
                  <span style={{ padding: '0.5rem' }}>Saber mais sobre o plano 3</span>
                </Button>
              </td>
            </tfoot>
          </table>
        </div>
      </Grid>
    </Container>
  );
}

export default Plans;
